import $ from 'jquery'
import get from 'lodash/get'
import isNil from 'lodash/isNil'

import * as Model from 'api/model'
import { targetGetCenter } from 'utils/target'

/**
 * Pozi MDL Google Forms Dialog Adapter
 */
export default function PoziFeedback () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    },
    buildGoogleForm: function (tabID, tabConfig) {
      return buildGoogleForm(tabID, tabConfig)
    },
    removeGoogleForm: function () {
      return removeGoogleForm()
    }
  }

  /**
   * Wireup events
   */
  var init = function () {
    $(window).on('beforeunload', function () {
      // Breakpoints set here will not trigger. Very hard to debug this code in this context.
      // To debug you would need to emulate by running the code and then reloading the page.
      console.log('beforeunload event remove google form to avoid nasty popups from google.')
      PoziFeedback().removeGoogleForm()
    })
  }

  /**
   * Show dialog
   * @param {object} e event
   * Required: e.currentTarget.googleFormsURL || e.currentTarget.attributes.googleFormsURL.nodeValue must be the google forms URL.
   * Optional: e.currentTarget.rawid || e.currentTarget.attributes.rawid.nodeValue can be set to a loaded featureset.
   */
  var buildGoogleForm = function (tabID, tabConfig) {
    console.log('PoziFeedback: Show google form in tab', tabConfig)

    $('#' + tabID).html('')

    let url = get(tabConfig, 'dataService.googleFormsURL', '')
    if (url === '') {
      console.log('Invalid Google Forms URL.')
      return
    }

    const targetCenter = targetGetCenter()
    if (isNil(targetCenter)) {
      console.error('Invalid target geojson! Must be a point type.')
      return
    } else {
      url = url.replace('[lng]', Math.round(targetCenter.geometry.coordinates[0] * 1000000) / 1000000)
      url = url.replace('[lat]', Math.round(targetCenter.geometry.coordinates[1] * 1000000) / 1000000)
      const layer = Model.get('app.drawer.tabs.info.addfeature.layer', null)
      if (!isNil(layer)) {
        url = url.replace('[layerid]', layer.titleid)
      }
    }

    $('#googleFormsFeedbackIFrame').remove() // Probably won't do anything... just in case user somehow exits the modal without clicking close.
    const iFrameHTML =
      '<div id="googleFormsFeedbackParent"><div id="googleFormsFeedbackIFrameLoading">Loading...</div><iframe id="googleFormsFeedbackIFrame" src=""></iframe></div>'
    $('#' + tabID).append(iFrameHTML)
    $('#googleFormsFeedbackIFrame').height($('.pozi-drawer-tabs-panel-wrapper').height())
    $('#googleFormsFeedbackIFrame').hide()
    $('#googleFormsFeedbackIFrameLoading').show()
    $('#googleFormsFeedbackIFrame').attr('src', url)

    // Give the google iFrame content time to load. Without this delay it looks a bit crap that the google form isn't yet loaded.
    window.setTimeout(function () {
      $('#googleFormsFeedbackIFrameLoading').hide()
      $('#googleFormsFeedbackIFrame').show()
    }, 2000)
  }

  /**
   * !!! To avoid the google form displaying a popup you need to remove the entire iFrame.
   *     See: https://productforums.google.com/forum/#!topic/docs/IOZbEbkxXrE
   */
  var removeGoogleForm = function () {
    console.log('Removing google iFrame to avoid popup message.')
    $('#googleFormsFeedbackParent').remove()
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
// End A (Adapter)
